/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import Helper from './Classes/Helper';
import FocusHandler from './Classes/FocusHandler';
import LazyLoad from 'vanilla-lazyload';
import ResponsiveTable from "./Classes/ResponsiveTable";
// import XDownloader from "./Classes/XDownloader";
import XDownloader from "xdownloader/XDownloader";
import Accordion from "./Classes/Accordion";
import HighlightsSlider from './Classes/HighlightsSlider';
import Video from './Classes/Video';
import CountUpNumbers from './Classes/CountUpNumbers';
import Header from './Classes/Header';
import ToTop from './Classes/ToTop';
import InteractiveSVGPopup from './Classes/InteractiveSVGPopup';

// import Jump from './Classes/Jump'
// import Sticky from '../../node_modules/sticky-js';
// import YoutubeLinks from './Classes/YoutubeLinks';

var focusHandlerInstance = null;
var lazyLoadInstance = null;
var responsiveTableInstance = null;
var downloaderInstance = null;

var accordionInstance = null;
var jumpInstance = null;
var youtubeLinksInstance = null;
var cvInstance = null;
var highlightsSliderInstane = null;
var videoInstance = null;
var countUpNumbersInstance = null;
var headerInstance = null;
var toTopInstance = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }

  // addYoutubeLink: (videoContainer) => {
  //   youtubeLinksInstance.addLink(videoContainer);
  // }

};


// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

  focusHandlerInstance = new FocusHandler();

  lazyLoadInstance = new LazyLoad();

  responsiveTableInstance = new ResponsiveTable({
    tableSelector: '.ns-table-wrap table',
    tableWrapperSelector: '.ns-table-wrap',
    breakPointLg: 1200,
    breakPointMd: 768,
    breakPointSm: 480,
    colCountNoSplit: 3,
    colCountEarlyBreak: 7,
    noSplitArray: []
  });

  downloaderInstance = new XDownloader({
    tableTitle: 'Belimo Group',
    tableSelector: '.ns-table-wrap',
    excludeTableSelector: 'div[data-tableid="Agenda"]',
    downloadText: " ", //Can be empty if you want to use an icon instead
    mergeStrings: [],
    numFmt: (cell, cellIndex, rowIndex) => {
      if ((String(cell.value).replace(' ', '')).trim().match(/^[+-]?(\d*\.\d+|\d+\.\d*|\d+)$/)) {
        cell.value = parseFloat(String(cell.value).trim().replace(' ', ''));
        if(String(cell.value).indexOf('.') > -1) {
          cell.numFmt = '#,##0.??';
        }
        else {
          cell.numFmt = '#,##0';
        }
        // console.log(cell._address, cell.value)
      }
    },
    tableCellFormatter: (h) => {
      let cell = document.createElement('td');
      cell.innerHTML = h.innerHTML;
      let superscript = cell.querySelector('.superscript');
      let superscriptContent = '';
      if (superscript) {
        superscriptContent = '(' + superscript.innerText + ')';
        superscript.parentNode.removeChild(superscript);
      }

      let cellContent = '';
      let cellSpans = cell.querySelectorAll('span');
      if (cellSpans.length > 0) {
        cellSpans.forEach(span => {
          cellContent += span.innerText
        })
      }else {
        let paragraph = cell.querySelector('p');
        cellContent += paragraph?.innerText;
      }

      return cellContent.replace(/'/g, '').replace(/’/g, '').replace(/–/g, '-').replace(/,/g, '.').replace(/–/g, '-').replace(/,/g, '.');
    },
    styles: [
      {
        class: 'head',
        font: {
          bold: true,
          color: {
            argb: 'FF000000'
          }
        },
        head: true,
        index: 10
      },
      {
        class: 'ns-borderbottom-bline',
        font: {
          bold: true
        },
        border: {
          bottom: {
            style: 'medium',
            color: {
              argb: 'FF000000'
            }
          },
        },
      },
      {
        class: 'ns-borderbottom-line',
        border: {
          bottom: {
            style: 'thin',
            color: {
              argb: 'FF000000'
            }
          },
        },
      },
      {
        class: 'ns-backgroundcolor-black',
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {
            argb: 'FFE7E7E7'
          }
        }
      }
    ]
  });

  cvInstance = new Accordion({ accordions: '.ns-cv__header' });
  cvInstance = new Accordion({ accordions: '.ns-sdg-accordion__header' });

  highlightsSliderInstane = new HighlightsSlider();

  countUpNumbersInstance = new CountUpNumbers({
    numbersSelector: '.countup .ns-keyfigure__figure',
    classIn: 'is-in-viewport',
    classOut: 'is-not-in-viewport',
    langArray: ['de-DE', 'en-US'],
    decimalArray: ['.', '.'],
    thousandSepArray: ['’', '’'],
  });
  videoInstance = new Video();

  headerInstance = new Header();

  accordionInstance = new Accordion({
    accordions: '.ns-accordion__head'
  });

  toTopInstance = new ToTop();

  new InteractiveSVGPopup('.svg-value-creation-model');

  // jumpInstance = new Jump({
  //   graphicSelector: '.ns-graphic'
  // });

  // youtubeLinksInstance = new YoutubeLinks({
  // });

});
